﻿export class PaymentAccountTypeService {

    public creditCardTypeCodeToName = (creditCardTypeCode: string): string => {
        if (creditCardTypeCode === "001") {
            return "VISA";
        }
        if (creditCardTypeCode === "002") {
            return "MASTERCARD";
        }
        if (creditCardTypeCode === "003") {
            return "AMERICAN EXPRESS";
        }
        if (creditCardTypeCode === "004") {
            return "DISCOVER";
        }
        return "";
    }

    public  bankAccountTypeCodeToName = (accountTypeCode: string): string => {
        if (accountTypeCode === "c") {
            return "CHECKING";
        }
        if (accountTypeCode === "s") {
            return "SAVINGS";
        }
        if (accountTypeCode === "x") {
            return "CORPORATE CHECKING";
        }

        if (accountTypeCode === "g") {
            return "GENERAL LEDGER";
        }
        return "";
    }
}